module.exports = __webpack_public_path__ + "img/laptop.jpg?4d68fcd1fb99c27c1be5edf77d5b7231";